{
  "projectedIncome": "Ingresos previstos",
  "totalProjectedIncome": "Ingresos previstos totales",
  "monthlyAverageIncome": "Ingreso mensual promedio",
  "noData": "No hay ingresos proyectados disponibles"
}
